import { ref } from 'vue';
import { type RouteRecordRaw } from 'vue-router';

import { type SharedPluginOptions } from '@deepidoo/deesplay-shared/plugins';
import { deesplayDark } from '@deepidoo/deesplay-shared/styles/deesplay-dark';
import { deesplayLight } from '@deepidoo/deesplay-shared/styles/deesplay-light';

import { routes } from '../features/main.router';
import coreDeDE from '../translations/de-DE.json';
import coreEnUS from '../translations/en-US.json';
import coreFrFR from '../translations/fr-FR.json';

export interface CorePluginOptions extends SharedPluginOptions {
	routes: RouteRecordRaw[];
}

export const defaultOptions = ref<CorePluginOptions>({
	locale: 'fr-FR',
	fallbackLocale: 'fr-FR',
	message: {
		'de-DE': coreDeDE,
		'en-US': coreEnUS,
		'fr-FR': coreFrFR
	},
	routes: routes,
	theme: 'LIGHT',
	themes: {
		DARK: deesplayDark,
		LIGHT: deesplayLight
	}
});